export const isPositiveAmount = (value: unknown): value is number => {
  if (value === null || value === undefined) {
    return false;
  }

  const numericValue = Number(value);
  return Number.isFinite(numericValue) && numericValue > 0;
};
